import rangoSalarialApi from "../../api/Alumno/rangoSalarialApi";
import { message } from 'antd';

export default {
    getRangoSalarial: async () => {
        const response = await rangoSalarialApi.getRangoSalarial();
        if (!response.success) {
            message.error(response.message);
            response.data = [];
        }
        return response;
    }
}